<div *ngIf="viewModel$ | async as viewModel" class="w-100 d-flex flex-row justify-content-between align-items-center border border-gray-200 rounded-all-1 py-4 px-3 bg-color-white">
  <div class="outstanding-container">
    <h3 class="mb-2 color-gray-500">{{ activeCurrency().symbol }} Total Outstanding</h3>
    <h1 class="mr-1">
      {{ viewModel?.totalOutstanding | currency : activeCurrency().code }}
    </h1>
    <div class="badge badge--info">
      <div class="badge__label">{{ viewModel?.unpaidInvoices + ' Invoice' + (viewModel?.unpaidInvoices === 1 ? '' : 's') }}</div>
    </div>
  </div>
  <div class="sub-totals-container">
    <div>
      <h6 class="mb-2">Available Credits</h6>
      <div class="sub-total-label__summary">
        <h3 class="mr-1">
          {{ viewModel?.credits.total | currency : activeCurrency().code }}
        </h3>
        <div class="badge badge--success" [tooltip]="creditsTooltip" position="below" [tooltipEnabled]="viewModel?.credits.count > 0">
          <div class="badge__label">{{ viewModel?.credits.count + ' Credit' + (viewModel?.credits.count === 1 ? '' : 's') }}</div>
          <ng-template #creditsTooltip>
            @for (client of viewModel?.credits?.clientBreakdown; track client.clientId) {
              <p>{{ client.clientName }}: {{ client.total | currency : activeCurrency().code }} ({{ client.count }} credit{{ client.count === 1 ? '' : 's' }})</p>
            }
          </ng-template>
        </div>
      </div>
    </div>
    <div>
      <h6 class="mb-2">Total {{ configService.lateFeeDisplayName | labelCase | pluralBasic }}</h6>
      <div class="sub-total-label__summary">
        <h3 class="mr-1">
          {{ viewModel?.lateFees.total | currency : activeCurrency().code }}
        </h3>
        <div class="badge badge--error" [tooltip]="lateFeesTooltip" position="below" [tooltipEnabled]="viewModel?.lateFees.count > 0">
          <div class="badge__label">{{ viewModel?.lateFees.count + ' ' + (configService.lateFeeDisplayName | titlecase | pluralBasic) }}</div>
          <ng-template #lateFeesTooltip>
            @for (client of viewModel?.lateFees?.clientBreakdown; track client.clientId) {
              <p>{{ client.clientName }}: {{ client.total | currency : activeCurrency().code }} ({{ client.count }} {{ client.count === 1 ? (configService.lateFeeDisplayName.slice(-1) === 's' ? (configService.lateFeeDisplayName | labelCase).slice(0, -1) : configService.lateFeeDisplayName | labelCase) : configService.lateFeeDisplayName | labelCase | pluralBasic }})</p>
            }
          </ng-template>
        </div>
      </div>
    </div>
    <div>
      <h6 class="mb-2">Past Due</h6>
      <div class="sub-total-label__summary">
        <h3 class="mr-1">
          {{ viewModel?.pastDue.total | currency : activeCurrency().code }}
        </h3>
        <div class="badge badge--error" [tooltip]="pastDueTooltip" position="below" [tooltipEnabled]="viewModel?.pastDue.count > 0">
          <div class="badge__label">{{ viewModel?.pastDue.count + ' Invoice' + (viewModel?.pastDue.count === 1 ? '' : 's') }}</div>
          <ng-template #pastDueTooltip>
            @for (client of viewModel?.pastDue?.clientBreakdown; track client.clientId) {
              <p>{{ client.clientName }}: {{ client.total | currency : activeCurrency().code }} ({{ client.count }} invoice{{ client.count === 1 ? '' : 's' }})</p>
            }
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
